import React, { useState, useEffect } from 'react';
import { baseCss } from '../css';

const nameRegex = /^[a-z][a-z ]*$/i;
const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const imobileRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
const ccRegex = /^(\+?\d{1,3}|\d{1,4})$/;
const gstRegex = /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/;
const txnpwdRegex = /^[a-zA-Z0-9]+$/;
const alpahNumeric = /^[a-zA-Z0-9]+$/;

export const isValidEmail = email => emailRegex.test(email);
export const isValidIndianMobile = mobile => Number.isInteger(parseInt(mobile)) && mobile.toString().length === 10;
export const isValidMynMobile = mobile => Number.isInteger(parseInt(mobile)) && mobile.toString().length >= 7 && mobile.toString().length <= 10;

export const isValidOtherMobile = mobile => imobileRegex.test(mobile.toString());
export const isValidGST = gst => gstRegex.test(gst);
export const isValidCC = cc => ccRegex.test(cc);

const GInput = ({ type = 'text', value, onChange, errMsg, label, validation, disabled, autoFocus, max, icon, icon2, iconError, readonly, onClick, onBlur, onIconClick, style, mandatory = false }) => {

    const [isFocus, setFocus] = useState(false);
    const [valid, setValid] = useState(false);
    const [isBlur, setBlur] = useState(false);

    const validator = (val) => {
        if (validation === 'name') {
            if ((nameRegex.test(val) || !val) && val.length < 30) {
                const isValid = val && val.trim().length >= 3;
                setValid(isValid);
                return (val);
            }
        }

        if (validation === 'age') {
            if ((Number.isInteger(parseInt(val)) || !val) && val.length < 3) {
                const isValid = Number.isInteger(parseInt(val)) && (errMsg.length > 20 && parseInt(val) < 12 ? false : true);
                setValid(isValid);
                return (parseInt(val) || '');
            }
        }

        if (validation === 'gender') {
            const isValid = val && val.trim().length >= 1;
            setValid(isValid);
            return (val);
        }

        if (validation === 'email') {
            setValid(isValidEmail(val));
            return (val);
        }

        if (validation === 'mobile') {
            if ((Number.isInteger(parseInt(val)) || !val) && val.length < 11) {
                setValid(isValidIndianMobile(val));
                //return (parseInt(val) || '');
                return (val);
            }
        }

        if (validation === 'mobile2') {
            if ((Number.isInteger(parseInt(val)) || !val) && val.length < 11) {
                setValid(isValidIndianMobile(val));
                return (parseInt(val) || '');
                // return (val);
            }
        }

        if (validation === 'mynmobile') {
            if ((Number.isInteger(parseInt(val)) || !val) && val.length < 11) {
                setValid(isValidMynMobile(val));
                return (parseInt(val) || '');
            }
        }

        if (validation === 'imobile') {
            if (val.length < 11) {
                setValid(val.length > 6);
                return (parseInt(val) || '');
            }
        }
        if (validation === 'cc') {
            if (val.length < 5 && (!isNaN(val) || val === '+' || val === '')) {
                setValid(isValidCC(val));
                return (val);
            }
        }
        if (validation === 'gst') {
            setValid(isValidGST(val));
            return (val);
        }
        if (validation === 'waitlistseat') {
            if ((Number.isInteger(parseInt(val)) || !val)) {
                const isValid = Number.isInteger(parseInt(val)) && (parseInt(val) < 7 ? true : false);
                setValid(isValid);
                return (parseInt(val) || '');
            }
        }
        if (validation === 'concessionType') {
            const isValid = val && val.trim().length >= 1;
            setValid(isValid);
            return (val);
        }

        if (validation === 'idCardNo') {
            const isValid = val && val.trim().length >= 3;
            setValid(isValid);
            return (val);
        }


        if (validation === 'idCardType') {
            const isValid = val && val.trim().length >= 3;
            setValid(isValid);
            return (val);
        }



        if (validation === 'nationality') {
            const isValid = val && val.trim().length >= 3;
            setValid(isValid);
            return (val);
        }

        if (validation === 'nationality') {
            const isValid = val && val.trim().length >= 3;
            setValid(isValid);
            return (val);
        }

        if (validation === 'countrycode') {
            const isValid = val && val.trim().length >= 3;
            setValid(isValid);
            return (val);
        }

        if (validation === 'password') {
            const isValid = val && val.trim().length >= 6;
            setValid(isValid);
            return (val);
        }

        if (validation === 'txn_password') {
            if ((txnpwdRegex.test(val) || !val) && val.length < 7) {
                const isValid = val && val.trim().length >= 4;
                setValid(isValid);
                return (val);
            }
        }

        if (validation === 'cancel_remark') {
            const isValid = val && val.trim().length >= 4;
            setValid(isValid);
            return (val);
        }

        if (validation === 'idCardNo2') {
            if ((alpahNumeric.test(val) || !val)) {
                setValid(true);
                return (val);
            }
        }

        if (validation === 'postal') {
            if ((alpahNumeric.test(val) || !val)) {
                setValid(true);
                return (val);
            }
        }

        if (validation === 'otp') {
            if (val.length < 7) {
                setValid(val.length >= 4);
                return (parseInt(val) || '');
            }
        }

        if (!validation) {
            setValid(true);
            return (val)
        }
        return false;
    }

    useEffect(() => {
        validator(value);
    })

    const handleBlur = () => {
        setFocus(false);
        setBlur(true);

        if (typeof onBlur === 'function') {
            onBlur();
        }
    }

    const handleChange = (e) => {
        if (typeof onChange === 'function') {
            const val = e.target.value;
            if (validator(val) || validator(val) === '') {
                onChange(validator(val));
            }
        }
    }

    const handleClick = () => {
        if (typeof onClick === 'function') {
            onClick();
        }
    }

    const handleIconClick = () => {
        if (typeof onIconClick === 'function') {
            onIconClick();
        }
    }

    const activeStyle = {
        borderWidth: 2,
        ...baseCss.primaryBorder
    }

    return (
        <div className={`inp-container${isFocus || (isBlur && !valid) ? ' extra' : ''}${isBlur && !valid ? ' err' : ''}${disabled ? ' disabled' : ''}`} style={style}>
            {icon && <span className={`icon-left ${isFocus || value.toString().length > 0 ? 'active' : ''}`}>{!isFocus && isBlur && !valid ? iconError ? iconError : icon : icon}</span>}
            {icon2 && <span className="icon-right" onClick={handleIconClick}>{icon2}</span>}
            <input
                type={type}
                value={value}
                onChange={handleChange}
                onFocus={() => setFocus(true)}
                onBlur={handleBlur}
                style={isFocus ? activeStyle : {}}
                disabled={disabled}
                autoFocus={autoFocus}
                autoComplete='off'
                maxLength={max}
                readOnly={readonly}
                onClick={handleClick}
                className={isFocus ? 'txtActive':''}
            />
            <label
                className={`${isFocus || value.toString().length > 0 ? 'active' : ''} ${!isFocus && isBlur && !valid ? 'lblerror' : ''}`}
                style={isFocus ? baseCss.primaryColor : {}}
            >{label}{mandatory ? <div style={{ color: 'red', display: 'inline-block' }}>*</div> : ''}</label>
            {
                !isFocus && isBlur && !valid && <span className="spnerrormsg">{errMsg}</span>
            }
        </div>
    )
}

export default GInput;